import React from 'react';
export const playerRef = React.createRef();
//# sourceMappingURL=playerRef.js.map